(() => {
  const instances = new Map();

  /**
   * Embla Carouselのインスタンスをセットアップする
   * @param {HTMLElement} emblaNode - カルーセルのルート要素
   */
  const setupEmbla = (emblaNode) => {
    // console.log('setupEmbla: カルーセルのセットアップを開始します。');
    const viewport = emblaNode.querySelector('.embla__viewport');
    if (!viewport) {
      console.error('setupEmbla: .embla__viewport が見つかりません。');
      return;
    }

    const { loop, autoplay, interval, arrows, dots, perPage, pauseOnHover } = emblaNode.dataset;
    const isSp = () => window.innerWidth < 750;

    // --- オプション設定 ---
    const options = {
      loop: isSp() ? true : loop === 'true',
      align: isSp() ? 'center' : 'start',
    };
    // console.log('setupEmbla: 初期化オプション:', options);

    // --- プラグイン設定 ---
    const plugins = [];
    if (autoplay === 'true' && typeof EmblaCarouselAutoplay === 'function') {
      plugins.push(
        EmblaCarouselAutoplay({
          delay: Number(interval) || 4000,
          stopOnInteraction: false,
          stopOnMouseEnter: pauseOnHover === 'true',
        })
      );
    }

    // --- Emblaインスタンス生成 ---
    const emblaApi = EmblaCarousel(viewport, options, plugins);
    // console.log('setupEmbla: Embla Carouselインスタンスを生成しました。');

    // --- ボタンのセットアップ ---
    const prevBtn = emblaNode.querySelector('.embla__prev');
    const nextBtn = emblaNode.querySelector('.embla__next');

    if (arrows === 'true' && prevBtn && nextBtn) {
      const onPrevButtonClick = () => {
        // console.log('Prevボタンがクリックされました。');
        emblaApi.scrollPrev();
      };
      const onNextButtonClick = () => {
        // console.log('Nextボタンがクリックされました。');
        emblaApi.scrollNext();
      };

      prevBtn.addEventListener('click', onPrevButtonClick, false);
      nextBtn.addEventListener('click', onNextButtonClick, false);

      // ボタンの有効/無効状態を更新
      const updateArrowButtons = () => {
        if (isSp()) {
          prevBtn.disabled = false;
          nextBtn.disabled = false;
        } else {
          prevBtn.disabled = !emblaApi.canScrollPrev();
          nextBtn.disabled = !emblaApi.canScrollNext();
        }
      };

      emblaApi.on('select', updateArrowButtons);
      emblaApi.on('init', updateArrowButtons);
    }

    // --- ドットボタンのセットアップ ---
    const dotsNode = emblaNode.querySelector('.embla__dots');
    if (dots === 'true' && dotsNode) {
      let dotNodes = [];
      const setupDots = () => {
        dotsNode.innerHTML = emblaApi.scrollSnapList().map(() => '<button type="button" class="embla__dot"></button>').join('');
        dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
        dotNodes.forEach((dotNode, index) => {
          dotNode.addEventListener('click', () => emblaApi.scrollTo(index), false);
        });
      };
      const updateDots = () => {
        const selectedIndex = emblaApi.selectedScrollSnap();
        dotNodes.forEach((dot, index) => {
          dot.classList.toggle('embla__dot--selected', index === selectedIndex);
        });
      };
      emblaApi.on('init', () => { setupDots(); updateDots(); });
      emblaApi.on('reInit', () => { setupDots(); updateDots(); });
      emblaApi.on('select', updateDots);
    }

    instances.set(emblaNode, emblaApi);
  };

  /**
   * 初期化処理
   */
  document.querySelectorAll('[data-embla-instance]').forEach(el => {
    // 依存ライブラリが読み込まれるのを待つ
    const checkDependencies = setInterval(() => {
      if (typeof EmblaCarousel === 'function' && typeof EmblaCarouselAutoplay === 'function') {
        clearInterval(checkDependencies);
        setupEmbla(el);
      }
    }, 100);
  });

  // --- Shopifyテーマエディタ用の処理 ---
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-embla-instance]');
    if (el) setupEmbla(el);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const el = e.target.querySelector('[data-embla-instance]');
    const inst = el && instances.get(el);
    if (inst) {
      inst.destroy();
      instances.delete(el);
    }
  });
})();
